<template>
  <div class="exercise-tracking">
    <AppHeader></AppHeader>
    <div class="page-wrapper">
      <div class="container-fluid">
        <!-- Title -->
        <div class="row heading-bg" style="padding-left: 13px;padding-right: 13px;">
          <div class="col-xs-12">
            <h5 class="txt-dark pull-left exercise-title">Gym Training</h5>
            <div class="pull-right">
              <button class="btn btn-nutri-green top-btn" data-toggle="modal" data-target="#historyModal" @click="getRecentExercises()">Recent Gym Exercises</button>
              <router-link to="/exercise/training">
                <button class="btn btn-nutri-green">Back to Personal Training</button>
              </router-link>  
            </div>
            <button v-if="tempExercise" @click="tempExercise = null;" class="pull-right top-btn btn btn-nutri-green">Back</button>
          </div>
        </div>
        <!-- Workout Modal -->
        <div class="modal fade" id="historyModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Recent Exercises</h5>
              <a class="modal-title pull-right close-btn" data-dismiss="modal" id="exampleModalLabel"><i style="font-size:25px;" class="zmdi zmdi-close"></i></a>
            </div>
            <div class="modal-body">
              <div class="row lines">
                <h6 class="col-md-11 align-middle">
                  Exercise Name
                </h6>
              </div>
              <div class="row">
                <div id="searchResultsContainer">
                  <ul>
                    <li class="workout-table" v-for="(item ,index) in recent_exercises" v-bind:key="index">
                      <div class="row lines" @click="tempMotion = item" style="cursor: pointer" data-toggle="modal" data-target="#trainingModal">
                        <h6 class="col-md-12 align-middle">
                          <img :src="item.thumb_image_url" style="width:50px; border-radius: 100px;"/>&nbsp;{{item.name}}
                        </h6>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="modal-footer" style="text-align:center !important;">
              <button style="width:70%;margin-left:0px;" type="button" class="btn btn-nutri-red" data-dismiss="modal">Close</button>
            </div>
            </div>
          </div>
        </div>
        <!-- Workout Modal -->
        <div v-if="tempMotion" class="modal fade" id="trainingModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">{{tempMotion.name}}</h5>
              <a class="modal-title pull-right close-btn" data-dismiss="modal" id="exampleModalLabel"><i style="font-size:25px;" class="zmdi zmdi-close"></i></a>
            </div>
            <div class="modal-body">
              <div class="row" style="text-align:center;">
                <img v-if="tempMotion.gif_image_url" :src="tempMotion.gif_image_url" style="height:300px;">
                <div style="padding-top:10px;">
                  <div class="row form-group" style="padding:10px; margin-right:15px;">
                    <div class="col-md-6">
                      <div class="input-group col-md-12">
                        <div class="col-md-3">
                          <label for="" style="padding-top:12px;">Set</label>
                        </div>
                        <div class="input-group col-md-9">
                          <input type="number" class="form-control" id="name" placeholder="Kg / Mins" v-model="intensity_value"> 
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="input-group col-md-12">
                        <div class="col-md-5" style="margin-left:-30px;margin-top:10px;">
                          <label for="">kg / mins x </label>
                        </div>
                        <div class="input-group col-md-7">
                          <input type="number" class="form-control" id="name" placeholder="Reps" v-model="duration_value">
                        </div>
                      </div>
                    </div>
                  </div>                
                  <div class="row form-group" style="text-align:center;padding-top:10px;">
                    <div class="col-md-3">
                      <label style="float:right;padding-top:12px;" for="">Rest</label>
                    </div>
                    <div class="col-md-6">
                      <input type="number" class="form-control" id="name" placeholder="Seconds" v-model="rest">
                    </div>
                    <div class="col-md-3">
                      <label style="float:left;padding-top:12px;" for="">Seconds</label>
                    </div>
                  </div>        
                    <div class="row">
                      <div class="col-md-12">
                        <div class="col-md-4">
                          <a href="#" class="btn btn-nutri-green btn-block" data-toggle="modal" data-target="#historyModal" @click="getHistory(tempMotion.id)">History</a>    
                        </div>
                        <div class="col-md-4">
                          <a href="#" class="btn btn-nutri-green btn-block" @click="addToSet">Add Set</a>    
                        </div>
                        <div class="col-md-4">
                          <button type="button" class="btn btn-nutri-green btn-block" data-dismiss="modal" @click="addToSet(); trackPersonalTraining(); resetModal();">Done</button>
                        </div>
                      </div>
                    </div>            
                  <!-- History Table -->
                  <div v-if="history.length != 0 && sets.length == 0" class="table-sets">
                    <h5>History</h5>
                    <table class="col-md-12 table table-responsive table-size" id="recipeingredients">
                      <tr>
                        <th style="text-align:center;">Sets</th>
                        <th style="text-align:center;">Date</th>
                      </tr>
                      <tr v-for="(item, index) in history" v-bind:key="index">
                        <td style="width:50%;">
                          <div v-for="(set, index) in item.sets" v-bind:key="index">
                            <p>Set #{{index + 1}}: {{set}}</p>
                          </div>
                        </td>
                        <td style="width:50%;vertical-align:middle;">
                          <p>{{item.date}}</p>
                        </td>
                      </tr>
                    </table>
                  </div>
                  <!-- Set Table -->
                  <div class="table-sets">
                    <table class="col-md-12 table table-responsive table-size" id="recipeingredients" v-if="sets.length > 0">
                      <tr>
                        <th style="text-align:center;">Kg</th>
                        <th style="text-align:center;">Reps</th>
                        <th>Remove</th>
                      </tr>
                      <tr v-for="(item, index) in sets" v-bind:key="index">
                        <td style="width:50%;">
                          {{item.intensity_value}}
                        </td>
                        <td style="width:50%;">
                          {{item.duration_value}}
                        </td>
                        <td style="text-align:center;">
                          <i style="font-size:26px;" @click="removeSet(index)" class="fa fa-times-circle"></i>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="" v-if="tempMotion.description">
                <h5 style="margin-left:15px;">Overview</h5>
                <div class="description" v-html="tempMotion.description">
                </div>
              </div>
            </div>
            <div class="modal-footer" style="text-align:center !important;">
              <button style="width:70%;margin-left:0px;" type="button" class="btn btn-nutri-red" data-dismiss="modal">Close</button>
            </div>
            </div>
          </div>
        </div>
        <!-- Page -->
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="panel panel-default card-view panel-refresh">
            <div class="refresh-container">
              <div class="la-anim-1"></div>
            </div>
            <div class="panel-heading">
              <h5 v-if="!showButton" class="txt-light pull-left">Choose Exercise</h5>
              <h5 v-if="showButton" class="txt-light pull-left">Choose Specific Exercise</h5>
              <div class="clearfix"></div>
            </div>
            <div id="collapse_1" class="panel-wrapper collapse in" v-if="!tempExercise">
              <div class="row">
                <div id="searchResultsContainer">
                  <!-- Exercise Plan List -->
                  <ul v-if="exercises.length > 0">
                    <li class="col-lg-12 col-md-12 col-xs-12 searchResult" v-for="(item,index) in exercises" v-bind:key="index" @click="getSpecificMotions(item);" v-if="item.personal_training == 1">
                      <a href="#">
                        <div class="row lines">
                          <div class="col-md-1 thumbImage">
                            <img class="thumbImage" v-if="item.image_url" :src="item.image_url ? item.image_url : 'https://s3.us-east-2.amazonaws.com/loopdigital-nutrivitas/defaultexercise.png'" alt=""/>
                          </div>
                          <h6 class="col-md-11 align-middle itemName">
                              {{item.name}}
                          </h6>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div id="collapse_1" class="panel-wrapper collapse in" v-else>
              <div class="row">
                <div id="searchResultsContainer">
                  <ul>
                    <li class="workout-table" v-for="(subitem,index) in specific_motions" v-bind:key="index">
                      <a v-if="subitem" href="#" data-toggle="modal" data-target="#trainingModal" @click="tempMotion = subitem; resetModal();">
                        <div class="row lines">
                          <div class="col-md-1 thumbImage">
                            <img class="thumbImage" v-if="subitem.thumb_image_url" :src="subitem.thumb_image_url ? subitem.thumb_image_url : 'https://s3.us-east-2.amazonaws.com/loopdigital-nutrivitas/defaultexercise.png'" alt=""/>
                          </div>
                          <h6 class="col-md-11 align-middle itemName">
                              {{subitem.name}}
                          </h6>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="backButton" v-if="choosenExercise">
              <button class="btn btn-nutri-green buttonBack" @click="choosenExercise = null">Back</button>  
          </div>
        </div>
        <AppFooter></AppFooter>
        <loading :active.sync="isLoading"></loading>
      </div>
    </div>
  </div>
</template>

<script>
import API from "../../services/api.js";
import AppHeader from "../../components/common/AppHeader.vue";
import AppFooter from "../../components/common/AppFooter.vue";
import Datepicker from "vuejs-datepicker";
import swal from "sweetalert";
import Loading from 'vue-loading-overlay';
	// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

const api = new API();

export default {
  components: {
    AppHeader,
    AppFooter,
    Datepicker,
    swal,
    Loading,
  },
  data() {
    return {
      isLoading: true,
      choosenExercise: null,
      tempMotion: { not_null:'not null' },
      exercises: [],
      tempExercise: null,
      exerciseWorkouts: [],
      showButton: false,
      recent_exercises: [],
      //set properties
      history: [],
      sets: [],
      intensity_value: null,
      duration_value: null,
      rest: null,
      num: null,
      specific_motions: [],
    };
  },
  created: function() {
    this.isLoading = true;
    api.getExercises().then(async response => {
      if (response.data.success) {
        this.exercises = response.data.data;
      }
    });
    this.isLoading = false;
  },
  methods: {
    getSpecificMotions(activity) {
      this.tempExercise = activity;
      api.getSpecificMotions(activity.id).then(async response => {
        if (response.data.success) {
          this.specific_motions = response.data.data.specific_motions;
        }
      });
    },
    getRecentExercises(){
      this.isLoading = true;
      this.showButton = true;
      api.getRecentExercises().then(async response => {
        if (response.data.success) {
          this.recent_exercises = response.data.data;
        }
      });
      this.isLoading = false;
    },
    getPlanWorkout(id){
      this.isLoading = true;
      this.showButton = true;
      api.getWorkoutExercises(id).then(async response => {
        if (response.data.success) {
          this.recent_exercises = response.data.data;
          this.isLoading = false;
        }
      });
    },
    getHistory(id){
      this.isLoading = true;
      api.getExerciseSetHistory(id).then(async response => {
        if (response.data.success) {
          this.history = response.data.data
          this.isLoading = false;
        }
      });
    },
    resetModal(){
      this.history = [];
      this.sets = [];
      this.intensity_value = null;
      this.duration_value = null;
      this.rest = null;
    },
    removeSet(value){
			this.sets.splice(value, 1)
		},
    addToSet(){
      if(this.intensity_value && this.duration_value) {
        this.num = this.num + 1
        let item = {
          "name": this.num,
          "intensity": 'Kg',
          "duration": 'reps',
          "intensity_value": this.intensity_value,
          "duration_value": this.duration_value,
          "done": false
        }
        this.sets.push(item)
        this.intensity_value = null;
        this.duration_value = null;
      }
    },
    trackPersonalTraining(){
      let data = { 
        activity_id: this.tempMotion.id,
        sets: this.sets,
        rest: this.rest
      }
      api.addPersonalTraining(data).then(async response => {
        if (response.data.success) {
          this.resetModal();
          // this.$router.push('/exercise')
        }
      });
    },
  }
};
</script>


<style scoped>
.top-btn{
  margin-right: 30px;
}

.workout-table{
  margin: 5px 0;
  font-size: small;
  border: 1px solid #ccc;
  padding: 10px;
  background: #f5f5f5;
}

.table-sets{
  padding:40px;
  padding-bottom:0px;
  height: 100%;
  max-height: 450px;
  overflow: auto;
}

.table-sets th {
  font-weight: bold;
  color :#c2c2c2;
  background-color: #333333;
}

#recipeingredients td,
#recipeingredients th {
  padding: 15px;
  margin: 15px;
  border: 1px solid #c2c2c2;
}

.lines{
  margin-top:-3px;
}

.close-btn{
  position:fixed;
  top:0;
  right:0;
  margin-right:15px;
  margin-top:15px;
}

.description{
  padding-left:15px;
  padding-right:15px;
  margin-top:5px;
}

#searchResultsContainer {
  height: 450px;
  padding: 5px;
  overflow: auto;
}
.searchResult {
  height: 75px;
  margin: 5px 0;
  font-size: small;
  border: 1px solid #ccc;
  padding: 15px;
  background: #f5f5f5;
}
.thumbImage {
  border-radius: 50%;
  height: 50px;
}
.itemName {
  padding-top: 1%;
  margin-left:-40px;
}
.backButton {
  padding-top: 20px;
  padding-bottom: 20px;
  text-align: center;
}

.buttonBack{
    width: 70%;
}

.exercise-title{
  margin-left:14px;
}

</style>



// WEBPACK FOOTER //
// src/views/Exercise/GymExercise.vue